export default function IncludedServices() {
  const services = [
    {
      icon: 'ri-flight-takeoff-line',
      title: 'Return Flights',
      description: 'Direct flights from London with reputable airlines, including baggage allowance'
    },
    {
      icon: 'ri-hotel-line',
      title: 'Premium Accommodation',
      description: 'Carefully selected hotels close to Haram, ensuring comfort and convenience'
    },
    {
      icon: 'ri-bus-line',
      title: 'Ground Transportation',
      description: 'All transfers between airports, hotels, and holy sites in air-conditioned coaches'
    },
    {
      icon: 'ri-guide-line',
      title: 'Expert Guidance',
      description: 'Experienced multilingual guides to assist throughout your spiritual journey'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Ziyarat Tours',
      description: 'Comprehensive tours of historical and religious sites in Makkah and Madinah'
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Meal Plans',
      description: 'Halal meals provided as per package selection, with dietary accommodations'
    },
    {
      icon: 'ri-customer-service-line',
      title: '24/7 Support',
      description: 'Round-the-clock assistance for any queries or emergencies during your trip'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Travel Insurance',
      description: 'Comprehensive travel insurance coverage for peace of mind (optional add-on)'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#C9A961] text-lg mb-4 italic" style={{ fontFamily: 'Playfair Display, serif' }}>
            /What's Included
          </p>
          <h2 className="text-5xl lg:text-6xl font-bold text-[#3A2F2B] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Comprehensive Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Every package is designed to provide a seamless, worry-free experience from departure to return
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="text-center group hover:transform hover:-translate-y-2 transition-all duration-300"
            >
              <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-[#FAF8F5] rounded-2xl group-hover:bg-[#C9A961] transition-colors duration-300">
                <i className={`${service.icon} text-4xl text-[#C9A961] group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1A1F2E] mb-3">{service.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
